
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import DownloadPage from '@/components/DownloadPage';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { trackPageView } from '@/lib/pageViewTracking';

const Download: React.FC = () => {
  const [searchParams] = useSearchParams();
  const trackId = searchParams.get('id') || '';
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(true);
  const [pageViewTracked, setPageViewTracked] = useState<boolean>(false);

  // Track page view when component mounts
  useEffect(() => {
    const trackView = async () => {
      if (trackId && !pageViewTracked) {
        try {
          // Track in database
          await trackPageView(trackId);
          console.log('Page view tracked for track:', trackId);
          
          // Also track in FB Pixel as custom event
          if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('trackCustom', 'TrackView', {
              track_id: trackId
            });
            console.log('FB Pixel: Track view tracked');
          }
          
          setPageViewTracked(true);
        } catch (error) {
          console.error('Failed to track page view:', error);
        }
      }
    };
    
    trackView();
  }, [trackId, pageViewTracked]);

  // Check auth state on component mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        setIsAuthenticated(!!data.session);
      } catch (error) {
        console.error('Error checking auth status:', error);
      } finally {
        setIsAuthLoading(false);
      }
    };

    checkAuth();

    // Subscribe to auth changes
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow pt-24 pb-20">
        <div className="container px-4 mx-auto">
          <div className="mb-4 text-center">
            {!isAuthenticated && !isAuthLoading && (
              <Link to="/register" className="text-primary hover:underline flex items-center justify-center mx-auto">
                Promote Your Track for FREE
                <ExternalLink size={16} className="ml-1" />
              </Link>
            )}
          </div>
          
          <DownloadPage trackId={trackId} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Download;

